import { Component, Injector, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FcItemListBaseComponent, FcListValidationService } from '../../generic';
import { ApAlertService } from 'webcommon/core-ui';
import { FcItemModalContext } from '../../../models';
import { FcFacilityPortalPersonListItemDto, FormGroupValidationRules } from 'webcommon/shared';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-name-details',
  templateUrl: './fc-name-details.component.html',
  styleUrls: ['./fc-name-details.component.less']
})
export class FcNameDetailsComponent extends FcItemListBaseComponent implements OnChanges {
  @Input() baseId: string;
  @Input() form: FormGroup;
  @Input() listItem: FcFacilityPortalPersonListItemDto;
  @Input() isSubmitted = false;
  @Input() itemContext: FcItemModalContext;

  public titleControl: FormControl = new FormControl<string>('');
  public firstNameControl: FormControl = new FormControl<string>('');
  public middleNameControl: FormControl = new FormControl<string>('');
  public lastNameControl: FormControl = new FormControl<string>('');
  public suffixControl: FormControl = new FormControl<string>('');
  public maidenNameControl: FormControl = new FormControl<string>('');
  public pronounUidControl: FormControl = new FormControl<string[]>([]);
  public akaFirstNameControl: FormControl = new FormControl<string>('');
  public akaLastNameControl: FormControl = new FormControl<string>('');

  public listItemDefaultValidation: FormGroupValidationRules = {
    Prefix: {
      MaxLength: 25,
    },
    FirstName: {
      IsRequired: true,
      MaxLength: 50,
    },
    MiddleName: {
      MaxLength: 50,
    },
    LastName: {
      IsRequired: true,
      MaxLength: 50,
    },
    MaidenName: {
      MaxLength: 50,
    },
    Suffix: {
      MaxLength: 50,
    },
    AkaFirstName: {
      MaxLength: 50,
    },
    AkaLastName: {
      MaxLength: 50,
    },
  };

  constructor(injector: Injector) {
    super(injector);

    this.formControlToCapitalizeWords(this.titleControl);
    this.formControlToCapitalizeWords(this.firstNameControl);
    this.formControlToCapitalizeWords(this.middleNameControl);
    this.formControlToCapitalizeWords(this.lastNameControl);
    this.formControlToCapitalizeWords(this.akaFirstNameControl);
    this.formControlToCapitalizeWords(this.akaLastNameControl);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.itemContext != null) {
      this.fcListValidation.initValidation(this.itemContext, this.listItemDefaultValidation);
    }
    if (changes.form != null) {
      this.addControlsToForm();
    }
    if (changes.itemContext != null || changes.form != null || changes.listItem != null) {
      this.setForm();
    }
  }

  public addControlsToForm(): void {
    this.form.addControl('title', this.titleControl);
    this.form.addControl('firstName', this.firstNameControl);
    this.form.addControl('middleName', this.middleNameControl);
    this.form.addControl('lastName', this.lastNameControl);
    this.form.addControl('suffix', this.suffixControl);
    this.form.addControl('maidenName', this.maidenNameControl);
    this.form.addControl('pronounUid', this.pronounUidControl);
    this.form.addControl('akaFirstName', this.akaFirstNameControl);
    this.form.addControl('akaLastName', this.akaLastNameControl);
  }

  private setForm(): void {
    // Title Control
    this.titleControl.setValidators(this.fcListValidation.getValidators('Prefix'));
    this.titleControl.setValue(this.listItem?.Prefix ?? '');

    // First Name Control
    this.firstNameControl.setValidators(this.fcListValidation.getValidators('FirstName'));
    this.firstNameControl.setValue(this.listItem?.FirstName ?? '');

    // Middle Name Control
    this.middleNameControl.setValidators(this.fcListValidation.getValidators('MiddleName'));
    this.middleNameControl.setValue(this.listItem?.MiddleName ?? '');

    // Middle Name Control
    this.lastNameControl.setValidators(this.fcListValidation.getValidators('LastName'));
    this.lastNameControl.setValue(this.listItem?.LastName ?? '');

    // Suffix Control
    this.suffixControl.setValidators(this.fcListValidation.getValidators('Suffix'));
    this.suffixControl.setValue(this.listItem?.Suffix ?? '');

    // Maiden Name Control
    this.maidenNameControl.setValidators(this.fcListValidation.getValidators('MaidenName'));
    this.maidenNameControl.setValue(this.listItem?.MaidenName ?? '');

    // Pronoun FindControl
    this.pronounUidControl.setValidators(this.fcListValidation.getValidators('PronounUid'));
    this.pronounUidControl.setValue(this.listItem?.PronounUid ? [this.listItem?.PronounUid] : []);

    // First Name Control
    this.akaFirstNameControl.setValidators(this.fcListValidation.getValidators('AkaFirstName'));
    this.akaFirstNameControl.setValue(this.listItem?.AkaFirstName ?? '');

    // Middle Name Control
    this.akaLastNameControl.setValidators(this.fcListValidation.getValidators('AkaLastName'));
    this.akaLastNameControl.setValue(this.listItem?.AkaLastName ?? '');
  }

  private formControlToCapitalizeWords(formControl: FormControl<string>): void {
    // Capitalize first letter of each words for FormControls

    formControl.valueChanges.pipe(this.takeUntilDestroy()).subscribe((value) => {
      if (typeof value !== 'string') return;
      const capitalizedString: string = value
        .split(' ') // Separate words by space
        .map((word) => {
          const letters = word.split('');
          if (letters.length > 0) {
            letters[0] = letters[0].toUpperCase();
          }
          return letters.join('');
        })  // Capitalize each words
        .join(' '); // Join capitalized words with spaces
      if (capitalizedString !== value) {
        formControl.setValue(capitalizedString);
      }
    });
  }
}
